var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9385 14.6338C41.7035 13.8694 41.7035 12.6293 40.9385 11.8649C38.1005 9.02696 34.147 7.63209 30.0911 8.03745C29.0807 8.13859 28.3275 8.9898 28.3275 9.98386C28.3275 10.0492 28.3308 10.115 28.3373 10.1803C28.445 11.2567 29.4052 12.0419 30.4808 11.9342C33.3632 11.6457 36.1659 12.63 38.1697 14.6338C38.934 15.3988 40.1742 15.3988 40.9385 14.6338Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 22.3879C53 10.0432 42.9568 0 30.6121 0C18.2673 0 8.22411 10.0432 8.22411 22.3879C8.22411 34.7327 18.2673 44.7759 30.6121 44.7759C42.9568 44.7759 53 34.7326 53 22.3879ZM12.1404 22.3879C12.1404 12.2024 20.4265 3.91631 30.6121 3.91631C40.7976 3.91631 49.0837 12.2024 49.0837 22.3879C49.0837 32.5728 40.7976 40.8596 30.6121 40.8596C20.4265 40.8596 12.1404 32.5735 12.1404 22.3879Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34273 52.4264L17.5718 38.1972C18.3368 37.4323 18.3368 36.1934 17.5718 35.4284C16.8074 34.6634 15.5673 34.6634 14.8029 35.4284L0.573893 49.6576C0.191402 50.04 0.000209808 50.5407 0.000209808 51.042C0.000209808 51.5433 0.191402 52.0439 0.573893 52.4264C1.33825 53.1913 2.57837 53.1913 3.34273 52.4264Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(53) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1e5652e1b8a1f328f3948873e612be91.svg";
export { ForwardRef as ReactComponent };